<template>
  <div>
    <div class="wz-page-header">
      <h1 class="wz-page-title">{{ editing ? "Editar banco" : "Nuevo banco" }}</h1>
    </div>

    <form @submit.prevent="save" novalidate>
      <wz-card :title="editing ? 'Datos del banco' : 'Datos del nuevo banco'">
        <div class="flex flex-wrap -mx-2">
          <div class="w-full md:w-1/3 mb-3 px-2">
            <wz-input
              label="Código"
              required
              v-model="form.code"
              placeholder="Ej: 002"
              :error="$v.form.code.$error && !$v.form.code.required ? 'El código es requerido' : ''"
            />
          </div>
          <div class="w-full md:w-2/3 mb-3 px-2">
            <wz-input
              label="Nombre"
              required
              v-model="form.name"
              placeholder="Nombre del banco"
              :error="$v.form.name.$error && !$v.form.name.required ? 'El nombre es requerido' : ''"
            />
          </div>
        </div>

        <div class="flex justify-end gap-2 mt-2">
          <wz-button variant="light" @click="$router.push({ name: 'bank-list' })">{{ editing ? "Volver" : "Cancelar" }}</wz-button>
          <wz-button type="submit" variant="primary" class="ml-2">Guardar</wz-button>
        </div>
      </wz-card>
    </form>
  </div>
</template>

<script>
import { Alert } from "@wizepe/wizeui"
import { required } from 'vuelidate/lib/validators'
import { BankService } from '@/core/services'

export default {
  data() {
    return { editing: false, form: { name: null, code: null } }
  },
  validations: { form: { name: { required }, code: { required } } },
  watch: { '$route.params.id'() { if (this.$route.params.id) this.load(this.$route.params.id) } },
  methods: {
    async save() {
      this.$v.$touch()
      if (this.$v.$error) return
      try {
        this.$store.dispatch('app/loading', true)
        const data = { name: this.form.name, code: this.form.code }
        let response
        if (!this.editing) response = await BankService.save(data)
        else response = await BankService.update(this.$route.params.id, data)
        Alert.success('Se almacenó la información correctamente')
        if (!this.editing) { this.$router.push({ name: 'bank-edit', params: { id: response.payload.id } }); this.editing = true }
      } catch (ex) { console.error(ex); Alert.error(ex.errors ? ex.errors.message : 'Error al guardar') }
      finally { this.$store.dispatch('app/loading', false) }
    },
    async load(id) {
      try {
        this.$store.dispatch('app/loading', true)
        const payload = (await BankService.get(id)).payload
        this.form = { name: payload.name, code: payload.code }
        this.editing = true
      } catch (e) { console.error(e); Alert.error(e.errors ? e.errors.message : 'Error al cargar'); this.$router.push({ name: 'bank-list' }) }
      finally { this.$store.dispatch('app/loading', false) }
    },
  },
  async created() { if (this.$route.params.id) this.load(this.$route.params.id) },
}
</script>
